<div
  class="mb-4 flex w-[640px] items-center rounded-sm px-2 py-4 shadow-lg backdrop-blur-xs transition-all duration-300 ease-in-out"
  [ngClass]="{
    'bg-signal-transparency-success-70 bg-opacity-70': mode === 'success',
    'bg-signal-transparency-error-70': mode === 'error',
    'bg-signal-transparency-warning-85': mode === 'warning',
    'bg-signal-transparency-info-70': mode === 'info'
  }"
  role="alert"
  [attr.aria-live]="mode === 'error' ? 'assertive' : 'polite'"
>
  <!-- Icons -->
  <div class="flex-shrink-0">
    <app-icon [icon]="getIcon(mode)" [iconWidth]="48" [iconHeight]="48" color="white"></app-icon>
  </div>

  <!-- Content -->
  <div class="ml-3 flex-1">
    @if (title) {
      <p class="text-xtra-large-semibold mb-1 text-center text-white">
        {{ title }}
      </p>
    }
    <p
      class="text-large-regular text-center"
      [ngClass]="{
        'text-signal-success-lighter': mode === 'success',
        'text-signal-error-lighter': mode === 'error',
        'text-signal-warning-lighter': mode === 'warning',
        'text-signal-info-lighter': mode === 'info'
      }"
    >
      {{ description }}
    </p>
  </div>

  <!-- Close Button -->
  <div class="ml-4 flex-shrink-0">
    <button (click)="closeNotification($event)" class="inline-flex rounded-md p-1.5 transition-colors" aria-label="Schließen" type="button">
      <app-icon icon="close" [iconWidth]="24" [iconHeight]="24" color="white"></app-icon>
    </button>
  </div>
</div>
